import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useGetSiteCredentialsQuery, useUpdateSiteCredentialsMutation } from './Api'
import Loader from "../loader/loader";
import toastService from "../../services/toastService";

const SiteSettings = () => {

    const validationSchema = Yup.object().shape({
        siteName: Yup.string()
            .required('Site name is required')
            .matches(
                /^[A-Za-z.\s]+$/,
                'Site name can only contain alphabets'
            )
            .min(2, 'Site name must be at least 2 characters')
            .max(50, 'Site name cannot exceed 50 characters')
            .trim(),
        logo: Yup.mixed().required("Logo is required"),
        favicon: Yup.mixed().required("Favicon is required"),
    });

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    const { data, isLoading } = useGetSiteCredentialsQuery()

    const [updateCredentialsApi, { isLoading: updateIsLoading }] = useUpdateSiteCredentialsMutation()


    // handle logo preview

    const [logoPreview, setLogoPreview] = useState(null);

    const handleLogoChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setLogoPreview(URL.createObjectURL(file));
        } else {
            setLogoPreview(null);
        }
    };

    // handle favicon preview

    const [faviconPreview, setFaviconPreview] = useState("");

    const handleFaviconChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            setFaviconPreview(URL.createObjectURL(file));
        } else {
            setFaviconPreview("");
        }
    };


    useEffect(() => {
        if (data?.data) {
            reset({
                siteName: data.data.site_name,
                logo: data.data.site_logo,
                favicon: data.data.site_favicon,
            })
            setLogoPreview(data.data.site_logo)
            setFaviconPreview(data.data.site_favicon)
        }

    }, [data])


    const validateLogo = (file) => {
        const supportedFormats = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "image/svg+xml",
        ];

        if (!supportedFormats.includes(file.type)) {
            toastService.error("Only JPG, JPEG, PNG, and SVG files are allowed");
            return false;
        }

        if (file.size > 2 * 1024 * 1024) {
            toastService.error("File size must be less than 2 MB");
            return false;
        }

        return true;
    };

    const validateFavicon = (file) => {
        const supportedFormats = [
            "image/x-icon",
            "image/vnd.microsoft.icon",
            "image/png",
            "image/svg+xml",
        ];

        if (!supportedFormats.includes(file.type)) {
            toastService.error("Only ICO, PNG, and SVG files are allowed");
            return false;
        }

        if (file.size > 1024 * 1024) {
            toastService.error("Favicon size must be less than 1 MB");
            return false;
        }

        return true;
    };

    const handleOnSubmit = async (data) => {
        try {

            console.log(data, 'data')
            const formData = new FormData();

            formData.append("siteName", data.siteName);

            if (data.logo instanceof FileList) {
                if (data.logo.length > 0) {
                    formData.append("logo", data.logo[0]);
                }
            } else if (typeof data.logo === "string") {
                formData.append("site_logo", data.logo);
            }

            if (data.favicon instanceof FileList) {
                if (data.favicon.length > 0) {
                    formData.append("favicon", data.favicon[0]);
                }
            } else if (typeof data.favicon === "string") {
                formData.append("site_favicon", data.favicon);
            }

            const response = await updateCredentialsApi(formData);

            if (response?.data?.success) {
                toastService.success(response.data.message);
            } else {
                toastService.error(response?.error?.data?.message);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };

    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <div className="smtp-card">

                    <form onSubmit={handleSubmit(handleOnSubmit)}>
                        <div className="d-flex justify-content-between align-items-center mb-4">

                            <div>
                                <h3 className="fw-bold mb-1">
                                    General Settings
                                </h3>

                                <p className="text-muted mb-0">
                                    Manage your website branding.
                                </p>
                            </div>

                            <button className="btn btn-primary" type="submit">
                                Save Changes
                            </button>

                        </div>
                        <div className="row">

                            <div className="col-md-6 smtp-field">
                                <label>Site Name</label>
                                <input type="text"
                                    id="siteName"
                                    name='siteName'
                                    {...register('siteName')}
                                    className="form-control"
                                    placeholder="Enter Site Name" />
                                {errors.siteName && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.siteName.message}
                                    </p>
                                )}
                            </div>


                            <div className="site-field">
                                <label>Logo</label>

                                <input
                                    type="file"
                                    id="logo"
                                    name='logo'
                                    className="form-control"
                                    style={{
                                        height: "33px",
                                        // width: "100%",
                                        // boxSizing: "border-box"
                                    }}
                                    onChange={(e) => {
                                        const file = e.target.files?.[0];

                                        if (!file) return;

                                        if (!validateLogo(file)) {
                                            e.target.value = "";
                                            return;
                                        }

                                        setValue("logo", e.target.files, {
                                            shouldValidate: true,
                                            shouldDirty: true
                                        });

                                        handleLogoChange(e);
                                    }}
                                    accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                                />

                                <div className="mt-3">
                                    {logoPreview ? (
                                        <img
                                            src={logoPreview}
                                            alt="Logo Preview"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                objectFit: "contain",
                                                border: "1px solid #ddd",
                                                borderRadius: "8px",
                                                padding: "5px",
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                border: "1px dashed #ccc",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#888",
                                                fontSize: "12px",
                                                background: "#fafafa",
                                            }}
                                        >
                                            No preview
                                        </div>
                                    )}
                                </div>
                                {errors.logo && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.logo.message}
                                    </p>
                                )}
                            </div>

                            <div className="site-field">
                                <label>Favicon</label>

                                <input
                                    type="file"
                                    id="favicon"
                                    name='favicon'
                                    className="form-control"
                                    style={{
                                        height: "33px",
                                        // width: "100%",
                                        // boxSizing: "border-box"
                                    }}
                                    onChange={(e) => {
                                        const file = e.target.files?.[0];

                                        if (!file) return;

                                        if (!validateFavicon(file)) {
                                            e.target.value = "";
                                            return;
                                        }

                                        setValue("favicon", e.target.files, {
                                            shouldValidate: true,
                                            shouldDirty: true
                                        });

                                        handleFaviconChange(e);
                                    }}
                                    accept=".ico,.png,.svg,image/x-icon,image/png,image/svg+xml"
                                />

                                <div className="mt-3">
                                    {faviconPreview ? (
                                        <img
                                            src={faviconPreview}
                                            alt="Favicon Preview"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                objectFit: "contain",
                                                border: "1px solid #ddd",
                                                borderRadius: "8px",
                                                padding: "5px",
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                border: "1px dashed #ccc",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#888",
                                                fontSize: "12px",
                                                background: "#fafafa",
                                                textAlign: "center",
                                                padding: "5px",
                                            }}
                                        >
                                            No preview
                                        </div>
                                    )}
                                </div>
                                {errors.favicon && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.favicon.message}
                                    </p>
                                )}
                            </div>



                        </div>

                    </form>

                </div>
            }
        </div>

    );
};

export default SiteSettings;